/**
 * Alopex-owned FHIR **identifier** systems.
 *
 * These are NOT canonical `/fhir/` URLs (so they are not generated into
 * `../generated/canonical-urls.ts`) and NOT external SDO systems (so they do
 * not belong in `./external-urls.ts`). They record numbers on
 * `Patient.identifier` and related.
 *
 * Consumers (bots' `BOT_CUSTOM_IDENTIFIER_SYSTEMS`, web's `fhir-systems.ts`)
 * re-export from here so the string literal has a single source of truth.
 * Migration files intentionally keep their own literals — they are frozen
 * history and must preserve the value as of their date.
 *
 * Note: Organization structural roots (entity root / customer root) are no
 * longer identifiers — they are codings on `Organization.type` from the
 * `organization-role` CodeSystem (see designs/TECH-Organizations.md).
 */
export const ALOPEX_IDENTIFIER_SYSTEMS = {
    /** SF1 document record identifier — used on DocumentReference.identifier for SF1-migrated documents. */
    SF1_DOCUMENT_ID: 'http://alopexcare.com/sf1/patientdocumentid',
    /** SF1 internal member/user identifier — used on Practitioner.identifier for SF1 users. */
    SF1_ORG_MEMBER_ID: 'http://www.alopexcare.com/sf1/organization-memberid',
    /** Alopex platform-wide medical record number, minted by the mint-mrn bot. */
    MRN: 'http://alopexcare.com/sf2/mrn',
    /** Referring provider / customer root medical record number. */
    CUSTOMER_MRN: 'http://alopexcare.com/customer/mrn',
    /**
     * External EMR system/vendor a facility's charts live in — the value on the
     * facility's `Endpoint.identifier` (e.g. `Aarista`). Generic across customers;
     * the vendor name is the identifier value, not baked into the system URL.
     */
    EMR_SYSTEM: 'http://alopexcare.com/emr/system',
    /**
     * EMR instance id — the small whole number surfaced as the "<EMR> ID" on the
     * patient record and used to group Genesys call work by EMR login
     * (`Endpoint.identifier`).
     */
    EMR_INSTANCE: 'http://alopexcare.com/emr/instance',
    /** EMR instance code — the EMR vendor's own instance/tenant code (`Endpoint.identifier`). */
    EMR_INSTANCE_CODE: 'http://alopexcare.com/emr/instance-code',
};
